import React from 'react';
import { Switch } from 'components/UI/V3/Forms/Switch/Switch';
import { Label } from 'components/UI/V3/Forms/Label/Label';
import styles from './EvaluationToggles.module.scss';
import { EvaluationExpiry } from 'model/Service';
import { FieldError } from '@spike/model';
import { getErrorMessage } from './Validations';
import CounterField from 'components/UI/V3/CounterField/CounterField';

interface EvaluationTogglesProps {
    evaluationExpiry: EvaluationExpiry | undefined;
    errors: Array<FieldError>;
    onlineBookingEnabled: boolean;
    onUpdateExpiryEnabled: (enabled: boolean) => void;
    onUpdateExpiryDuration: (duration: number) => void;
    onUpdateOnlineBooking: (enabled: boolean) => void;
}

export const EvaluationToggles: React.FC<EvaluationTogglesProps> = ({
    evaluationExpiry,
    errors,
    onlineBookingEnabled,
    onUpdateExpiryEnabled,
    onUpdateExpiryDuration,
    onUpdateOnlineBooking
}) => {
    return (
        <>
            {/* Online Booking Toggle */}
            <div className={styles.toggleSection}>
                <div className={styles.toggleRow}>
                    <div>
                        <Label>Online Booking</Label>
                    </div>
                    <Switch
                        checked={onlineBookingEnabled}
                        onChange={checked => onUpdateOnlineBooking(checked)}
                        inlineLabel="Bookable online"
                    />
                </div>
            </div>

            {/* Evaluation Expiry Toggle */}
            <div className={styles.toggleSection}>
                <div className={styles.toggleRow}>
                    <div className={styles.toggleExpiry}>
                        <Label>Evaluation Expiry</Label>
                        <Switch
                            checked={evaluationExpiry?.enabled}
                            onChange={checked => onUpdateExpiryEnabled(checked)}
                        />
                    </div>
                </div>

                {/* Duration Input - Show when expiry is enabled */}
                {evaluationExpiry?.enabled && (
                    <>
                        <Label className={styles.toggleDescription}>
                            How many months of no visits before an eval expires and a new one is required.
                        </Label>
                        <div className={styles.formRow}>
                            <div className={styles.formSection}>
                                <CounterField
                                    value={parseInt(evaluationExpiry.duration, 10)}
                                    onChange={e => onUpdateExpiryDuration(e)}
                                    minLimit={1}
                                    maxLimit={24}
                                />
                                <Label error={getErrorMessage(errors, 'evaluationExpiry')}>Months</Label>
                            </div>
                        </div>
                    </>
                )}
            </div>
        </>
    );
};

export default EvaluationToggles;
